import { ECOPROTOKEN_CLAIMS } from "../../constants/AppConstants";
import { getUserDataByKey, getUserSessionData } from "../Authentication/handleUserSession";

const UpdateUserAddressPayload = ( {userAddress} ) => {
  const UID = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
  const firstName = getUserDataByKey('firstName', 'personal_details');
  const lastName = getUserDataByKey('lastName', 'personal_details');

  const payload = {
    userId: UID || null, 
    FirstName: firstName || "",
    LastName: lastName || "",
    addressId:userAddress?.addressId || 0, 
    addressLine1: userAddress?.addressLine1 || "", 
    addressLine2: userAddress?.addressLine2 || "", 
    cityTown: userAddress?.cityTown || "", 
    state: userAddress?.state || "", 
    country: userAddress?.country || "", 
    postCode: userAddress?.postCode || "", 
    companyName: userAddress?.companyName || "",
    addressName: userAddress?.addressName || null
  };
  return payload;
};

export default UpdateUserAddressPayload;
